import Vue from 'vue';
import { ROUTE_API_POST_VALIDATION_ERRORS } from '@/constants/apiRoutes';

export const createValidationData = (obj) => {
  const fields = [];

  Object.entries(obj).forEach((formField) => {
    const fieldValues = Object.values(formField);
    const fieldName = fieldValues[0];
    const fieldError = fieldValues[1].error;

    const inputValue = checkValue(fieldName, fieldValues[1].value);

    if (fieldError) {
      fields.push({
        field: fieldName,
        error: fieldError,
        value: inputValue,
      });
    }
  });

  const validationErrorData = {
    url: window.location.href,
    errorContent: fields,
  };

  Vue.axios.post(ROUTE_API_POST_VALIDATION_ERRORS, validationErrorData);
};

function checkValue(fieldName, value) {
  if (value === '') {
    return 'Feld leer';
  }

  if (fieldName.toLowerCase().includes('password')) {
    return '';
  }
  if (fieldName.toLowerCase() === 'email') {
    const hasAtSign = /@/.test(value);
    const hasSuffix = /\s*[A-Z0-9._%+-]+\.[A-Z]{2,}\s*/i.test(value);
    const hasWhitespace = / /.test(value);
    return `${!hasAtSign ? '@ fehlt,' : ''} ${!hasSuffix ? 'Suffix fehlt,' : ''} ${
      hasWhitespace ? 'beinhaltet Leerzeichen,' : ''
    } ${!hasWhitespace && hasAtSign && hasSuffix ? 'beinhaltet unerlaubte Zeichen,' : ''} `;
  }

  if (fieldName.toLowerCase().includes('name')) {
    const isTooLong = value.length > 255;
    return `${isTooLong ? 'über 255 Zeichen,' : 'beinhaltet unerlaubte Zeichen,'}`;
  }

  return value;
}
